import {createRouter, createWebHistory} from 'vue-router'
import MainPageView from "@/views/MainPageView";
import AddTeamView from "@/views/AddTeamView";
import MeetingTypesView from "@/views/MeetingTypesView";
import TeamsView from "@/views/TeamsView";
import LoginView from "@/views/LoginView";
import RegisterView from "@/views/RegisterView";
import ForgotPasswordView from "@/views/ForgotPasswordView";
import ResetPasswordView from "@/views/ResetPasswordView";
import AccessView from "@/views/AccessView";
import AuthService from "@/services/auth";

const routes = [
    {
        path: '/login',
        name: 'Login',
        component: LoginView,
        meta: {public: true}
    },
    {
        path: '/register',
        name: 'Register',
        component: RegisterView,
        meta: {public: true}
    },
    {
        path: '/forgot-password',
        name: 'Forgot password',
        component: ForgotPasswordView,
        meta: {public: true}
    },
    {
        path: '/reset-password',
        name: 'Reset password',
        component: ResetPasswordView,
        meta: {public: true}
    },
    {
        path: '/',
        name: 'Main page',
        component: MainPageView
    },
    {
        path: '/teams',
        name: 'Teams',
        component: TeamsView
    },
    {
        path: '/teams/add',
        name: '+ add team',
        component: AddTeamView
    },
    {
        path: '/teams/:id',
        name: 'UDT',
        component: TeamsView
    },
    {
        path: '/meeting-types',
        name: 'Meeting Types',
        component: MeetingTypesView
    },
    {
        path: '/access',
        name: 'Access',
        component: AccessView
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

router.beforeEach(async (to) => {
    if (to.meta.public) {
        return true;
    }
    const auth = new AuthService();
    const ok = await auth.validateToken();
    if (!ok) {
        return {name: 'Login', query: {redirect: to.fullPath}};
    }
    return true;
})

export default router
